import React, {useEffect, useRef, useState} from 'react';
import './styles.css';
import ChevronDownIcon from "../../../assets/icons/ChevronDownIcon";
import colors from "../../../utils/Colors";

const DropdownMenu = ({
                          triggerContent,
                          children,
                          styles = {},
                          childStyles = {},
                          classes = '',
                          searchBy = null,
                          variant = 'default',
                          disabled = false,
                          closeOnInsideClick = true,
                          showChevron = true,
                          direction = 'bottom',
                      }) => {

    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);
    const [firstTimeOpened, setFirstTimeOpened] = useState(false);
    const dropdownContainerRef = useRef(null);

    const toggleDropdown = () => setIsOpen(!isOpen);

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsOpen(false);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === "Escape") {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        if (isOpen) {
            setFirstTimeOpened(true);
            document.addEventListener('click', handleClickOutside);
            document.addEventListener("keydown", handleKeyDown);
            if (searchBy && searchInputRef.current) {
                searchInputRef.current.focus();
            }
            if (dropdownContainerRef.current) {
                dropdownContainerRef.current.classList.remove("d-n");
            }
        } else {
            setTimeout(() => {
                if (dropdownContainerRef.current) dropdownContainerRef.current.classList.add('d-n')
            }, 350);
            document.removeEventListener('click', handleClickOutside);
            document.removeEventListener("keydown", handleKeyDown);
        }
        return () => {
            document.removeEventListener('click', handleClickOutside);
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [isOpen]);

    return (
        <div style={styles} className={'dropdown-menu-parent-div ' + classes} ref={dropdownRef}>
            <div
                className={`dropdown ${isOpen ? 'show' : ''} ${variant}`}
                onClick={toggleDropdown}
                style={{
                    justifyContent: showChevron ? 'space-between' : 'center',
                }}
            >
                <div>
                    {triggerContent}
                </div>

                {showChevron &&
                    <ChevronDownIcon
                        width="16"
                        height="16"
                        stroke="currentColor"
                        style={{marginRight: '5px', flexShrink: 0, color: colors.silverDark}}
                    />
                }

            </div>
            <div
                style={childStyles}
                key={'dropdown-menu'}
                className={`dropdown-menu ${isOpen ? 'show' : firstTimeOpened ? 'hidden' : 'd-n'} ${direction}`}
                ref={dropdownContainerRef}
            >
                {/* overflowX has to be named: setting only overflow-y makes the
                    browser treat overflow-x as auto too, and any row a pixel
                    over put a scrollbar along the bottom of the menu */}
                <div style={{maxHeight: '280px', overflowY: 'auto', overflowX: 'hidden'}}
                     onClick={() => closeOnInsideClick ? setIsOpen(false) : ''}>
                    {children}
                </div>
            </div>
        </div>
    );
};

export default DropdownMenu;



// WEBPACK FOOTER //
// ./src/components-new/ui/DropdownMenu/index.jsx